// extracted by mini-css-extract-plugin
export default {"__mask":"MatrixRain___mask__qpyGh"};